/**
 * Every icon the app uses, named by role rather than by picture.
 *
 * Call sites ask for `copy` or `externalLink`, never for a Solar icon name, so
 * swapping or restyling the set is a change to this file alone. Solar has six
 * weights; `-linear` is the default here and `-bold` is used only where the old
 * icon was a solid shape.
 *
 * Adding an entry is not enough on its own - the icon data is bundled, not
 * fetched at runtime. Run `npm run icons` to regenerate `solar.json`.
 */
export const ICONS = {
  /** FAQ entries, and the "need help?" affordance on the status pages. */
  help: "solar:question-circle-linear",
  /** Dismisses the tracking detail panel. */
  close: "solar:close-linear",
  /** Copies the tracking number. */
  copy: "solar:clipboard-linear",
  /** Solid bullet marking a topic on the order timeline. */
  timelineDot: "solar:circle-dot-bold",
  /** Outlined bullet marking an individual timeline entry. */
  timelineStep: "solar:circle-dot-linear",
  /** An attachment on a timeline entry. */
  attachment: "solar:paperclip-linear",
  /** A timeline entry that links off-site, e.g. a carrier's tracking page. */
  externalLink: "solar:square-arrow-right-up-linear",
  /** The address in the site footer. */
  location: "solar:map-point-linear",
};

/** The Solar names, for the generator script. */
export const ICON_NAMES = Object.values(ICONS);
